import moment from "moment";
import {

  allDates
} from "./commonFunctions";

import { controls } from './controls';



const showroom4 = {
  label: "showroom4",
  pageLabel: "showroom 4 ",
  starting: true,
  url: "showroom4",
  pageType: "history",
  formTabs: {
    allTabs: [
      {
        label: "Modal",
        uid: "Modal",
        style: {
          textDecoration: "underline"
        }
      },
      {
        label: "Magic Date",
        uid: "mdate",
        // style: {
        //   textDecoration: "underline"
        // }
      }, {
        label: "Other Controls",
        uid: "othercontrol",
        // style: {
        //   textDecoration: "underline"
        // }
      }, {
        label: "QR Code Scanner",
        uid: "Qrcode",
        // style: {
        //   textDecoration: "underline"
        // }
      },
      {
        label: "Web Camera",
        uid: "cameraphoto",
        // style: {
        //   textDecoration: "underline"
        // }
      },
      {
        label: "Plain Modal",
        uid: "plainmodal",
        // style: {
        //   textDecoration: "underline"
        // }
      },
      {
        label: "Editor",
        uid: "plaineditor",
        // style: {
        //   textDecoration: "underline"
        // }
      },



    ]
  },
  form: [
    ...controls.displayText({ tab: "Modal", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "Modal", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "Modal", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "Modal", label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "product_code_display", name: "product_code_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Customer Number", width: "col-sm-2" }),
    ...controls.customerNumber({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "customer_number_display", name: "customer_number_display", width: "col-sm-2", displaytype: 'titlecase' }),

    ...controls.displayText({ tab: "Modal", label: "Account Number", width: "col-sm-2" }),
    ...controls.AccountNumber({ tab: "Modal", forceRender: true, beforeLeave: ["createAcNo"] }),
    ...controls.showData({ tab: "Modal", data: "account_number_display", name: "account_number_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "General Ledger", width: "col-sm-2" }),
    ...controls.GL({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "gl_code_display", name: "gl_code_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Customer Group", width: "col-sm-2" }),
    ...controls.CustomerGroup({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "customer_group_display", name: "customer_group_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "State", width: "col-sm-2" }),
    ...controls.State({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "state_display", name: "state_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "District", width: "col-sm-2" }),
    ...controls.District({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "district_display", name: "district_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Taluka", width: "col-sm-2" }),
    ...controls.Taluka({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Village", width: "col-sm-2" }),
    ...controls.Village({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "village_display", name: "village_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Marital Status", width: "col-sm-2" }),
    ...controls.MaritalStatus({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "marital_status_display", name: "marital_status_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Occupation", width: "col-sm-2" }),
    ...controls.Occupation({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "occupation_display", name: "occupation_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Religion", width: "col-sm-2" }),
    ...controls.Religion({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "religion_display", name: "religion_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Cast", width: "col-sm-2" }),
    ...controls.Cast({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "cast_display", name: "cast_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Proof Of Address", width: "col-sm-2" }),
    ...controls.POA({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "proof_of_address_display", name: "proof_of_address_display", width: "col-sm-2", displaytype: "sentencecase" }),

    ...controls.displayText({ tab: "Modal", label: "Proof Of Identity", width: "col-sm-2" }),
    ...controls.POI({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "proof_of_identity_display", name: "proof_of_identity_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Income Group", width: "col-sm-2" }),
    ...controls.IncomeGroup({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "income_group_display", name: "income_group_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Division", width: "col-sm-2" }),
    ...controls.Division({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "division_display", name: "division_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Sub Division", width: "col-sm-2" }),
    ...controls.SubDivision({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "sub_division_display", name: "sub_division_display", width: "col-sm-2", displaytype: 'capital' }),


    ...controls.displayText({ tab: "Modal", label: "Joint Type", width: "col-sm-2" }),
    ...controls.JointType({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "jointtype_code_display", name: "jointtype_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Relation Code", width: "col-sm-2" }),
    ...controls.RelationCode({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "relation_code_display", name: "relation_code_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Reason", width: "col-sm-2" }),
    ...controls.Reason({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "reason_display", name: "reason_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Title", width: "col-sm-2" }),
    ...controls.Title({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "title_display", name: "title_display", width: "col-sm-2" }),


    ...controls.displayText({ tab: "Modal", label: "Ledger Group", width: "col-sm-2" }),
    ...controls.ledgergroup({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "ledger_group_display", name: "ledger_group_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Area", width: "col-sm-2" }),
    ...controls.Area({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "area_display", name: "area_display", width: "col-sm-2" }),
    ...controls.showData({ tab: "Modal", data: "area_pin_display", name: "area_pin_display_show", width: "col-sm-2" }),
    ...controls.displayText({ tab: "Modal", width: "col-sm-4" }),

    ...controls.displayText({ tab: "Modal", label: "In Number", width: "col-sm-2" }),
    ...controls.numtoword({ tab: "Modal", convertedTo: "entered_amount_text", name: "entered_amount", width: "col-sm-2" }),
    ...controls.showData({ tab: "Modal", data: "entered_amount_text", name: "entered_amount_text", width: "col-sm-8" }),


    ...controls.displayText({ tab: "Modal", label: "AADHAR Number", width: "col-sm-2" }),
    ...controls.aadharNumber({ tab: "Modal", width: "col-sm-4" }),
    ...controls.displayText({ tab: "Modal", label: "PAN Number", width: "col-sm-2" }),
    ...controls.panNumber({ tab: "Modal", width: "col-sm-4" }),
    ...controls.displayText({ tab: "Modal", label: "Mobile Number", width: "col-sm-2" }),
    ...controls.mobileNumber({ tab: "Modal", name: "mobile_number", width: "col-sm-4" }),
    ...controls.displayText({ tab: "Modal", label: "Email", width: "col-sm-2" }),
    ...controls.Email({ tab: "Modal", name: "email_id", width: "col-sm-4" }),
    ...controls.displayText({ tab: "Modal", label: "Pincode", width: "col-sm-2" }),
    ...controls.pinCode({ tab: "Modal", name: "pincode", width: "col-sm-4" }),

    ...controls.displayText({ tab: "Modal", label: "Float", width: "col-sm-2" }),
    ...controls.floatOnly({ tab: "Modal", name: "float", width: "col-sm-4" }),

    ...controls.displayText({ tab: "Modal", label: "Text Control", width: "col-sm-2" }),
    ...controls.text({ tab: "Modal", name: "text_control", width: "col-sm-4", placeHolder: "Text Control" }),

    ...controls.displayText({ tab: "Modal", label: "Text Area", width: "col-sm-2" }),
    ...controls.textArea({ tab: "Modal", name: "text_area", width: "col-sm-4", placeHolder: "Text Area" }),

    ...controls.displayText({ tab: "Modal", label: "Number Only", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "Modal", name: "number_only", width: "col-sm-4", placeHolder: "Number Only" }),

    ...controls.displayText({ tab: "Modal", label: "Date Picker", width: "col-sm-2" }),
    ...controls.datePicker({ tab: "Modal", name: "date_picker", width: "col-sm-4", placeHolder: "Date Picker", defaultValue: "" }),
    ...controls.displayText({ tab: "Modal", label: "BirthDay", width: "col-sm-2" }),
    ...controls.datePicker({ tab: "Modal", name: "birthday", width: "col-sm-2", defaultValue: "", convertedTo: "age_text" }),
    ...controls.showData({ tab: "Modal", data: "age_text", name: "age_text", width: "col-sm-2" }),

    ...controls.magicDateLabel({ tab: "Modal", label: "Date To Duration", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "Modal", name: "date_to_dueration", width: "col-sm-2", convertedTo: "return_duration", dateType: "ontype", }),
    ...controls.showData({ tab: "Modal", data: "return_duration", name: "return_duration", width: "col-sm-2" }),

    ...controls.displayText({ tab: "Modal", label: "Select", width: "col-sm-2" }),
    ...controls.select({
      tab: "Modal", name: "select", width: "col-sm-4", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "individual",
        value: "individual"
      },
      {
        label: "internal",
        value: "internal"
      }]
    }),
    ...controls.displayText({ tab: "Modal", label: "DataList", width: "col-sm-2" }),
    ...controls.dataList({
      tab: "Modal", list: "firstlist", name: "datalist", width: "col-sm-4", placeHolder: "Datalist", defaultValue: "",
      options: [{
        label: "individual",
        value: "individual"
      },
      {
        label: "internal",
        value: "internal"
      }, ,
      {
        label: "Other",
        value: "other"
      }]
    }),

    ...controls.displayText({ tab: "Modal", label: "Acutocomplet", width: "col-sm-2" }),
    ...controls.autoComplete({
      tab: "Modal", name: "autocomplete", width: "col-sm-4", placeHolder: "Autocomplete",
      defaultValue: "",
      options: [{
        label: "Normal",
        value: "Normal"
      }, {
        label: "display",
        value: "display"
      }
      ], ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      }
    }),
    ...controls.checkBox({ tab: "Modal", label: "Active", name: "isActive", width: "col-sm-6", default: true }),
    ...controls.radio({
      tab: "Modal", name: "gender", width: "col-sm-6", options: [
        { label: "Male", value: "M" },
        { label: "Female", value: "F" },
      ]
    }),
    ...controls.Multibutton({
      tab: "Modal",
      name: "cdFlag",
      width: "col-sm-4",
      Bcolor: "success",
      options: [
        { label: "Credit", value: "credit", width: "col-sm-3" },
        { label: "Debit", value: "debit", width: "col-sm-3" },
      ]
    }),


    ...controls.displayText({ tab: "Modal", label: "Acutocomplete Multiple", width: "col-sm-2" }),
    ...controls.autoCompleteMultiple({
      tab: "Modal", name: "autocomplete_multi", width: "col-sm-4",
      placeHolder: "Autocomplete Multi",

      options: [{
        label: "product1",
        value: "product1"
      },
      {
        label: "product2",
        value: "product2"
      },], ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getState",
          fieldType: "string",
          filters: ["pageData", "State"]
        },
        label: "display",
        value: "display"
      }
    }),


    ...controls.displayText({ tab: "mdate", label: "Date", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "mdate", name: "defdate", width: "col-sm-2" }),

    ...controls.magicDateLabel({ tab: "mdate", label: "OnType Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "mdate", restrictions: { min: {}, max: {}, skip: [{ type: 'dow', val: 'sunday' }] }, name: "ontype_date", dateType: "ontype", displayFormat: "dd/MM/yyyy", width: "col-sm-2", }),

    // ...controls.displayText({tab: "mdate",label: "Month Dropdown",width:"col-sm-2 "}),
    // ...controls.magicDate({tab: "mdate",name:"dropdown_month",width:"col-sm-2",dateType:"month"}),
    // ...controls.displayText({tab: "mdate",label: "Short Month ",width:"col-sm-2 "}),
    // ...controls.magicDate({tab: "mdate",name:"short_month",width:"col-sm-2",dateType:"shortmonth"}),
    // ...controls.displayText({tab: "mdate",label: "Time Only ",width:"col-sm-2 "}),
    // ...controls.magicDate({tab: "mdate",name:"time_only",width:"col-sm-2",dateType:"timeonly"}),
    // ...controls.displayText({tab: "mdate",label: "Year Dropdown ",width:"col-sm-2 "}),
    // ...controls.magicDate({tab: "mdate",name:"year_dropdown",width:"col-sm-2",dateType:"year"}),
    // ...controls.displayText({tab: "mdate",label: "Month Year Dropdown ",width:"col-sm-2 "}),
    // ...controls.magicDate({tab: "mdate",name:"monthyear_dropdown",width:"col-sm-2",dateType:"monthyear"}),
    // ...controls.displayText({tab: "mdate",label: "Week Number ",width:"col-sm-2 "}),
    // ...controls.magicDate({tab: "mdate",name:"weeak_num",width:"col-sm-2",dateType:"weekdates"}),
    // ...controls.displayText({tab: "mdate",label: "Multi months ",width:"col-sm-2 "}),
    // ...controls.magicDate({tab: "mdate",name:"multi_month",width:"col-sm-2",dateType:"multimonths"}),
    // ...controls.displayText({tab: "mdate",label: "Disable Date ",width:"col-sm-2 "}),
    // ...controls.magicDate({tab: "mdate",name:"disable_date",width:"col-sm-2",dateType:"disabled"}),
    ...controls.displayText({ tab: "othercontrol", label: "Sanction By", width: "col-sm-2" }),
    ...controls.SanctionBy({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", name: "sanctionby_display", data: "sanctionby_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "othercontrol", label: "Referenced By", width: "col-sm-2" }),
    ...controls.ReferencedBy({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", name: "referencedby_display", data: "referencedby_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "othercontrol", label: "Purpose", width: "col-sm-2" }),
    ...controls.Purpose({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", name: "purpose_display", data: "purpose_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "othercontrol", label: "Priority Sector", width: "col-sm-2" }),
    ...controls.PrioritySector({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", name: "priority_sector_display", data: "priority_sector_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "othercontrol", label: "Priority Segment", width: "col-sm-2" }),
    ...controls.PrioritySegment({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", name: "priority_segment_display", data: "priority_segment_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "othercontrol", label: "Category", width: "col-sm-2" }),
    ...controls.Category({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", name: "category_display", data: "category_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "othercontrol", label: "Industry Type", width: "col-sm-2" }),
    ...controls.IndustryType({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", name: "industrytype_display", data: "industrytype_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "othercontrol", label: "Health", width: "col-sm-2" }),
    ...controls.Health({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", name: "health_display", data: "health_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "othercontrol", label: "CIBIL Account Type", width: "col-sm-2" }),
    ...controls.CIBILAccountType({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", name: "cibil_account_type_display", data: "cibil_account_type_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "othercontrol", label: "Society", width: "col-sm-2" }),
    ...controls.Society({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", name: "society_display", data: "society_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "othercontrol", label: "Ref Director", width: "col-sm-2" }),
    ...controls.RefDirector({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", name: "ref_director_display", data: "ref_director_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "othercontrol", label: "Gold Code", width: "col-sm-2" }),
    ...controls.GoldCode({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", name: "gold_code_display", data: "gold_code_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "othercontrol", label: "Member No", width: "col-sm-2" }),
    ...controls.MemberNo({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.displayText({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.displayText({ tab: "othercontrol", label: "Security", width: "col-sm-2" }),
    ...controls.Security({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", name: "security_display", data: "security_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "othercontrol", width: "col-sm-2", label: "Vehicle Type" }),
    ...controls.VehicleType({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", data: "vehicletype_display", name: "vehicletype_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "othercontrol", label: "Account Type", width: "col-sm-2 " }),
    ...controls.AccountType({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", data: "account_type_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "othercontrol", label: "Mode Of Operation", width: "col-sm-2 " }),
    ...controls.ModeOfOperation({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", data: "mode_of_operation_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "othercontrol", label: "Product Type", width: "col-sm-2 " }),
    ...controls.ProductType({ tab: "othercontrol", width: "col-sm-2" }),
    ...controls.showData({ tab: "othercontrol", data: "product_type_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "othercontrol", label: "Cheque Number", width: "col-sm-2 " }),
    ...controls.chequeNumber({ tab: "othercontrol", width: "col-sm-2" }),

    {
      inputType: "fileupload", name: "myNewFile", tab: "othercontrol", widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      }
    },

    ...controls.qrCodeReader(),
    ...controls.webCamera(),
    {
      inputType: "simplemodal",
      tab: "plainmodal",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      label: "Plain Modal",
      description: "none",
      parents: [
        {
          name: "pan_number",
          match: "in",
          value: ["x"],
          // show:
        }
      ]
    },
    {
      inputType: "simpleeditor",
      tab: "plaineditor",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      label: "Simple Editor",
      name: "simpleeditor",
      description: "none",
    }


  ]

};

export default showroom4;